import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import store from 'store'

dayjs.extend(customParseFormat)

const TOKEN_MAP = { GG: 'DD', AA: 'MM', YYYY: 'YYYY' }
const PROJECT_FORMATS = ['GG.AA.YYYY', 'GG/AA/YYYY', 'AA/GG/YYYY', 'YYYY-AA-GG']
export const DEFAULT_PROJECT_FORMAT = 'GG.AA.YYYY'

export const getProjectDateFormat = () => {
    const fmt = store.getState()?.auth?.user?.date_format
    return PROJECT_FORMATS.includes(fmt) ? fmt : DEFAULT_PROJECT_FORMAT
}

export const toDayjsFormat = (projectFmt = getProjectDateFormat()) =>
    projectFmt.replace(/GG|AA|YYYY/g, (t) => TOKEN_MAP[t])

const toDayjs = (value) => {
    if (value === null || value === undefined || value === '') return null
    if (dayjs.isDayjs(value)) return value.isValid() ? value : null
    if (value instanceof Date) {
        const d = dayjs(value)
        return d.isValid() ? d : null
    }
    if (typeof value === 'number') {
        // 10 haneli timestamp = saniye, 13 haneli = ms
        const ms = value < 1e12 ? value * 1000 : value
        const d = dayjs(ms)
        return d.isValid() ? d : null
    }
    if (typeof value === 'string') {
        const num = Number(value)
        if (!Number.isNaN(num) && /^\d+$/.test(value)) {
            const ms = num < 1e12 ? num * 1000 : num
            const d = dayjs(ms)
            return d.isValid() ? d : null
        }
        // Önce projenin formatıyla parse etmeyi dene, sonra ISO/native
        const projectFmt = toDayjsFormat()
        const projectParsed = dayjs(value, projectFmt, true)
        if (projectParsed.isValid()) return projectParsed
        const native = dayjs(value)
        return native.isValid() ? native : null
    }
    return null
}

export const formatDate = (value, projectFmt) => {
    const d = toDayjs(value)
    if (!d) return ''
    return d.format(toDayjsFormat(projectFmt))
}

export const parseDate = (str, projectFmt) => {
    if (!str) return null
    const d = dayjs(str, toDayjsFormat(projectFmt), true)
    return d.isValid() ? d.toDate() : null
}

// HTML <input type="date"> her zaman ISO ister
export const toInputDate = (value) => {
    const d = toDayjs(value)
    return d ? d.format('YYYY-MM-DD') : ''
}
